import { AnswersMap } from '@models';

/** Smart Functional Intake Form; assignments without a version get its latest version. */
export const SMART_FORM_TEMPLATE_ID = 'smart-form-template-v1';

export interface Assignment {
  id: string;

  templateId: string;
  templateVersion: number;

  status: 'inProgress' | 'completed';

  answers: AnswersMap;

  metadata: {
    createdAt: string;
    updatedAt: string;
    submittedAt?: string;
  };
}
